import TabsContainer from './TabsContainer';
import Tab from './Tab';
var TAB_NAMES = ['react', 'vue', 'angular'];
export default {
  TabsContainer: TabsContainer,
  TAB_NAMES: TAB_NAMES,
  Tab: Tab
};